// extracted by mini-css-extract-plugin
module.exports = {"modal__form":"styles_modal__form__1zk5Y","modal__inner":"styles_modal__inner__Kfns7","modal__button":"styles_modal__button__2sDqp"};